import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Button, Confirm, Dimmer, Form, Header, Icon, Loader, Message, Segment } from "semantic-ui-react";
import { InfoCircle } from "../../components/info-circle";
import { DialogService } from "../../services/dialog-service";
import { ActionStore } from "../../stores/action-store";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { App } from "../../stores/models/app";
import { Project } from "../../stores/models/project";
import { ProjectMember } from "../../stores/models/project-member";
import { User } from "../../stores/models/user";
import { ProjectStore } from "../../stores/project-store";
import { UserStore } from "../../stores/user-store";
import { EditorPane } from "../common/editor-pane";
import { ProjectMemberEditor } from "./project-member-editor";

declare var toastr: any;

interface IProjectEditorProps{
	appStore?: AppStore;
	projectStore?: ProjectStore;
	authStore?: AuthStore;
	userStore?: UserStore;
	actionStore?: ActionStore;
	project?: Project;
	show?: boolean;
	onClose?(): void;
}

interface IProjectEditorState{
	usernameInput?: string;
	showConfirm?: boolean;
}

@inject("appStore", "projectStore", "authStore", "userStore", "actionStore") @observer
export class ProjectEditor extends React.Component<IProjectEditorProps, IProjectEditorState>{
	constructor(props, state){
		super(props, state);

		this.state = {"usernameInput": "", "showConfirm": false};

		this.handleAddUser = this.handleAddUser.bind(this);
		this.addUser = this.addUser.bind(this);
		this.handleRemoveUser = this.handleRemoveUser.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleRefresh = this.handleRefresh.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.closeConfirm = this.closeConfirm.bind(this);
	}

	async componentDidMount(){
		//console.log("componentDidMount", this.props.show);
		if(this.props.show){
			this.load(this.props);
		}
	}
	async componentWillReceiveProps(nextProps: IProjectEditorProps){
		//console.log("componentWillReceiveProps", this.props.show, nextProps.show);
		if(nextProps && nextProps.show){
			this.load(nextProps);
		}
	}

	async load(props: IProjectEditorProps, loadApps: boolean = false){
		if(props.project){
			await props.project.loadMembers();
		}
		if(loadApps){
			await props.actionStore.loadActions(true, true);
			await props.appStore.loadApps(true, true);
		}
	}

	async handleAddUser(ev){
		ev.stopPropagation();
		ev.preventDefault();
		if(this.props.authStore.user.accountType === 0){
			await this.addUser();
		}
		else{
			this.setState({
				"showConfirm": true
			});
		}
	}

	async addUser(){
		await this.props.actionStore.loadActions(true, true);
		await this.props.appStore.loadApps(true, true);

		await this.props.project.addMember(this.state.usernameInput);
		toastr.success("Change Saved");
		this.setState({
			"showConfirm": false
		});
	}

	closeConfirm(){
		this.setState({
			"showConfirm": false
		});
	}

	async handleRemoveUser(pm: any){
		await this.props.project.removeMember(pm.id);
		this.load(this.props);
	}

	handleClose(){
		if(this.props.onClose){
			this.props.onClose();
		}
	}

	async handleRefresh(){
		await this.load(this.props, true);
	}

	handleInputChange(ev){
		this.setState({"usernameInput": ev.target.value});
	}


	render(){
		let manageURL = "";
		if(this.props.project && this.props.project.userApps){
			let pdApp = _.find(this.props.appStore.apps, app => {return app.name === "Project Details"; });
			let pdUserApp = _.find(this.props.project.userApps, app => {return app.id === pdApp.id; });
			if(!_.isNil(pdApp) && !_.isNil(pdUserApp)){
				manageURL = pdApp.settingsUrl + "?jpt=" + pdUserApp.token;
			}
		}


		return (
			<div>
				<Confirm open={this.state.showConfirm} onConfirm={this.addUser} onCancel={this.closeConfirm} content={
					<p style={{"padding": "20px 20px 0px 20px"}}>
						Please be careful when adding users to your study and granting view or edit permissions, keeping in mind any non-disclosure, data access, and/or other legal requirements.  Jibunu will not be responsible for any costs associated with any changes additional users may make.  Permissions can be removed at any time.  Click on the&nbsp;
							<InfoCircle header="App Name">
								App Permission Description
							</InfoCircle>
							next to each application to get more details on each tool and access type.  If you have any questions, please contact <a href="mailto:projects@jibunu.com">projects@jibunu.com</a>.
					</p>
					}
				/>
				<EditorPane title={`Project Members (${this.props.project ? this.props.project.surveyId : ""})`} show={this.props.show} onClose={this.handleClose} onRefresh={this.handleRefresh} width={1000}>
					{((this.props.project && this.props.project.loading) || this.props.appStore.loading || this.props.actionStore.loading) && <Dimmer active><Loader active /></Dimmer>}
					{!_.isNil(this.props.project) &&
						<Segment raised>
							<Header className="jibunu-blue">Available Users</Header>
							<Form onSubmit={this.handleAddUser}>
								<Form.Group inline>
									<Form.Field inline>
										<Form.Input type="email" name="user" placeholder="Enter email" value={this.state.usernameInput} onChange={this.handleInputChange} style={{"width": "300px"}} />
									</Form.Field>
									<Form.Field inline>
										<Form.Button inline type="submit" primary icon="add" labelPosition="left" content="Add" />
									</Form.Field>
								</Form.Group>
							</Form>
							<a href={manageURL} target="_blank">
								<Button className="jibunu-orange" icon="users" content="Manage Sample Provider Mapping" labelPosition="left" size="small" />
							</a>
							<Header className="jibunu-blue">Members</Header>
							<div>
								{this.props.project && this.props.project.members.length > 0 && this.props.project.members.map((pm: ProjectMember) => {
									return (
										<ProjectMemberEditor key={pm.id} member={pm} project={this.props.project} onRemoveMember={this.handleRemoveUser} />
									);
								})}
								{this.props.project && this.props.project.members.length == 0 &&
									<div>
										Project has no members
									</div>
								}
							</div>
						</Segment>
					}
					<br />
					<Button primary onClick={this.handleClose} content="Close" />
					{this.props.project && this.props.project.errorMessage &&
						<Message icon color="red">
							<Icon name="warning sign" />
							{this.props.project.errorMessage}
						</Message>
					}
				</EditorPane>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projects/project-editor.tsx